<template>
  <LayoutEmpty>
    <div
      class="container"
      id="subscribe">
      <section class="main">
        <div class="girl-container"></div>
        <div class="content-container">
          <div class="content">
            <router-link :to="{name: 'home'}">
              <div class="logo"></div>
            </router-link>
            <Spinner v-if="purchaseOptions.loading"/>
            <div v-for="tokenPlan in purchaseOptions.data"
                :key="tokenPlan.id">
                <router-link :to="{ name: 'purchase.subscription', query: { plan: tokenPlan.id } }">
                  <div class="token-plan-container">
                    <div class="description">
                      <h3>&#128293; {{tokenPlan.subscription_plan.data.tokens_quantity}} Tokens </h3>
                      <h5>{{$t('subscription.payment_type.single', {amount: Number(tokenPlan.subscription_plan.data.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), currency_symbol: showCurrency.symbol, currency_description: ''})}}</h5>
                    </div>
                    <div class="price">
                      <span class="currency">U$</span> 
                      {{Number(tokenPlan.subscription_plan.data.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), showCurrency.symbol}}
                    </div>
                 </div>
                </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </LayoutEmpty>
</template>

<script>
import LayoutEmpty from "../../../layouts/LayoutEmpty";
import Footer from "../../../components/Footer";
import Spinner from "../../../components/Spinner";
import resources from '../../../resources';

  export default {
    components: {
      LayoutEmpty,
      Footer,
      Spinner
    },
    data(){
      return {
        countries: {
          data: [],
          loading: true,
          error: false,
        },
        purchaseOptions: {
          data: [],
          loading: true,
          error: false,
        },
        fullLoading: false,
        selectedCountry: null,
        internationalCurrency: null,
      }
    },
    computed: {
      showCurrency(){
        return this.selectedCountry ? this.selectedCountry.show_currency.data : this.internationalCurrency;
      },
    },
    methods: {
      loadPurchaseOptions(){
              this.purchaseOptions.data = [];
              this.purchaseOptions.error = false;
              this.purchaseOptions.loading = true;

              resources.purchaseOptions.index({
                country_id: this.selectedCountry ? this.selectedCountry.id : 'INT',
                include: ['subscription_plan.payment_methods', 'subscription_plan.onward_subscription_plan', 'subscription_plan.one_click_pay_cards'],
                code: this.promotionalCode,
                referal: this.referalCode,
                plan: this.suscriptionPlanIdEntered,
                webstar: this.webstarIdEntered,
                tokens: 1,
              })
                .then((response) => {
                    this.purchaseOptions.loading = false;
                    this.purchaseOptions.data = response.data.data;
                    this.checkAlreadySubscribed();
                }).catch((err) => {
                    this.purchaseOptions.loading = false;
                    this.purchaseOptions.error = true;
                })
          },
      loadCountries(){
            this.countries.data = [];
            this.countries.loading = true;
            this.countries.error = false;

            Promise.all([
              resources.countries.index({payable: 1, per_page: 999, include: ['is_current', 'show_currency'],}),
              resources.currencies.index({default: 1}), //Es para traer la default para el "internacional", despues cada pais trae su moneda o la default
            ])
            .then(([countriesResponse, currencyResponse]) => {
              this.internationalCurrency = currencyResponse.data.data[0];
              this.countries.data = countriesResponse.data.data;
              this.countries.loading = this.countries.error = false;
              this.selectedCountry = this.countries.data.find(country => country.is_current === true) || null;
              this.loadPurchaseOptions();

              if(!this.internationalCurrency) {
                return this.countries.error = true;
              }
            }).catch((err) => {
              this.countries.loading = false;
              this.countries.error = true;
            });
          },
    },
    mounted(){
      this.loadCountries();
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../styles/variables';
  @import '../../../styles/classes';

  #subscribe {
    background-color: var(--pallete_dark_color);
    color: var(--pallete_clear_text_color);
    display: flex;
    flex-direction: column;
    padding: 1em;

    .error{
      text-align: center;
    }

    .subscription-container{
      min-height: 400px;
    }
    
    section.main{
      display: flex;
      justify-content: space-around;
      position: relative;

      .girl-container{
        flex: 1;
        background-image: url('/img/subscribe_girl.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center right;
        z-index: 0;
        max-height: 100vh;
        min-height: 500px;

        @media(max-width: 980px){
          position: absolute;
          left: -200px;
          width: 400px;
          height: 100%;

          background-position: center center;
        }

        @media(max-width: 600px){
          left: 0;
          width: 100%;
          height: 100%;
          min-height: auto;
          max-height: inherit;
          background-position: center center;
          opacity: .35;
        }
      }

      .content-container{
        position: relative;
        z-index: 1;
        flex: 1.5;
        padding: 20px 0;

        @media(max-width: 980px){
          padding-left: 20%;
        }

        @media(max-width: 600px){
          padding-left: 0;
          padding-top: 2em;

          .logo{
            height: 30px;
          }
        }

        @media(max-height: 750px){
          min-height: 100vh;
        }

        .content{
          min-height: 350px;
          width: 500px;
          margin: auto;

          .logo{
            display: block;
            margin: auto;
            margin-bottom: 20px;
            height: 50px;
            width: 100%;
            background-image: var(--img-logo);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
          }

          @media(max-width: 600px){
            width: 100%;
            font-size: .9em;
          }
        }
          .support-link{
              display: block;
              width: fit-content;
              margin: 0 auto;
          }
      }
    }
  }

  .token-plan-container {
    align-items: center;
    background-color: var(--pallete_dark_color);
    border: solid 1px white;
    border-radius: 1rem;
    display: flex;
    font-size: 1.2rem;
    flex-direction: row;
    padding: 0.5rem 1.5rem;
    margin-bottom: 1rem;
    transition: border 1s ease-out 10ms;

    &:hover {
      border: solid 1px var(--pallete_main_color);
    }

    .description {
      flex:1;
    }

    h3 {
      font-size: 1.7rem;
      padding: 0;
      margin: 1rem 0;
    }

    h5 {
      padding: 0;
      margin: 1rem 0 1rem 0.50rem;
    }

    .price {
      color: var(--pallete_main_color);
      font-size: 2rem;
      font-weight: bold;
    }

    .currency {
      font-size: 1rem;
    }
  }
</style>
